<button (click)="exportItems()" [disabled]="loadingExport">
    <img
        src="../../assets/icons/downloadIcon.svg"
        alt="Ícone de Download"
    />
    {{ text }}
</button>